import { render, staticRenderFns } from "./DesktopDropDown.vue?vue&type=template&id=68ed5858&scoped=true&"
import script from "./DesktopDropDown.vue?vue&type=script&lang=js&"
export * from "./DesktopDropDown.vue?vue&type=script&lang=js&"
import style0 from "./DesktopDropDown.vue?vue&type=style&index=0&id=68ed5858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed5858",
  null
  
)

export default component.exports